/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ShareClassEnum } from './share-class-enum';
import { CompanyInvestor } from './company-investor';
import { InvestmentExportStatusEnum } from './investment-export-status-enum';

export interface InvestmentsExport {
  readonly status: InvestmentExportStatusEnum;
  readonly allocation_date: string;
  readonly share_class: ShareClassEnum;
  readonly share_price: string;
  readonly investors: Array<CompanyInvestor>;
}
export namespace InvestmentsExport {}
